export default {
	unexpectedError: "Unexpected error: {message}",
	workStyleError: "Failed to save work style assessment",
};
